<template>
  <div>
    <v-autocomplete dense v-if="edit"
      v-model="model"
      :items="items"
      :loading="loading"
      :search-input.sync="search"
      :disabled="disabled"
      :label="label"
      :value="addressText"
      cache-items
      hide-no-data
      hide-selected
      item-text="address"
      item-value="dpid"
      outlined
      clearable
      prepend-inner-icon="room"
      return-object
      autofocus
      menu-props="closeOnClick"
      @focus.native="$event.target.select()"
      @blur="edit = false"
      @change="emitValue"
    >
    <!--
      <template v-slot:append>
        <transition name="fade">
          <div>
            <v-btn x-small fab color="info lighten-2" class="mr-2"><v-icon>check</v-icon></v-btn>
            <v-btn x-small fab color="white"><v-icon>cached</v-icon></v-btn>
          </div>
        </transition>
      </template>
    -->
    </v-autocomplete>
    <v-text-field dense :disabled="disabled" v-else v-model="address"
      prepend-inner-icon="room"
      :rules="rules" @click="editAddress"
      :label="label" readonly outlined>
    </v-text-field>
  </div>
</template>

<script>
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import UtilService from '@/services/UtilService.js'

@Component
export default class AddressTextField extends Vue {
  @Prop(String) label
  @Prop(String) dpid
  @Prop(String) address
  @Prop(Boolean) disabled
  @Prop(Array) rules

  model = ''
  addressText = ''
  loading = false
  edit = false
  items = []
  search = null

  @Watch('search')
  onSearch (val) {
    if (this.loading) return
    if (!val || val.length <= 8) return
    if (val === this.address) {
      return
    }
    this.searchAddress(val)
  }

  editAddress () {
    this.items = [{
      dpid: this.dpid,
      address: this.address
    }]
    this.model = this.items[0].dpid
    this.addressText = this.items[0].address
    this.edit = true
  }

  searchAddress (v) {
    this.loading = true
    UtilService.searchAddress(v)
      .then(resp => (this.items = resp.data))
      .catch(err => console.error(err))
      .finally(() => (this.loading = false))
  }

  emitValue () {
    this.$emit('input', this.model ? String(this.model.dpid) : null)
    this.addressText = this.model ? this.model.address : ''
    this.$emit('text-change', this.addressText)
    this.edit = false
  }
}
</script>
